// extracted by mini-css-extract-plugin
module.exports = {"w1fyi19c":"w1fyi19c"};